// Entrada do Service Level: só aparece para quem tem a feature
// service-level (o acesso real é validado no backend).
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import styled from '@emotion/styled'
import {getCompanyFeatures} from '../../api/index'

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  background: linear-gradient(110deg, #00335d 0%, #005282 100%);
  border-radius: 14px;
  padding: 20px 24px;
  margin-bottom: 20px;

  .sl-card-texto {
    flex: 1;
    min-width: 0;
  }

  .sl-card-tag {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #74c7ff;
    margin-bottom: 4px;
  }

  h3 {
    color: #fff;
    font-size: 17px;
    font-weight: 700;
    margin: 0 0 4px;
  }

  p {
    color: #c7ddec;
    font-size: 13px;
    margin: 0;
  }

  @media (max-width: 600px) {
    padding: 20px;
    .sl-card-texto {
      flex-basis: 100%;
    }
    a.sl-card-btn {
      width: 100%;
      text-align: center;
    }
  }

  a.sl-card-btn {
    background: #0078bd;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    padding: 10px 18px;
    border-radius: 8px;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      background: #0066a2;
      color: #fff;
    }
  }
`

const ServiceLevelCard: FC = () => {
  const [temAcesso, setTemAcesso] = useState(false)

  useEffect(() => {
    let ativo = true
    getCompanyFeatures()
      .then((res: any) => {
        if (ativo) setTemAcesso(!!res?.data?.some((f: any) => f.name === 'service-level'))
      })
      .catch(() => {})
    return () => {
      ativo = false
    }
  }, [])

  if (!temAcesso) return null

  return (
    <Card>
      <div className='sl-card-texto'>
        <span className='sl-card-tag'>Service Level</span>
        <h3>Nível de Serviço · Sellers</h3>
        <p>
          Acompanhe NS, prazo de entrega e cortes dos distribuidores, com detalhes até o pedido.
        </p>
      </div>
      <Link to='/service-level/dashboard' className='sl-card-btn'>
        Acessar painel →
      </Link>
    </Card>
  )
}

export {ServiceLevelCard}
